import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import styles from "./apiList.less";
import shrinkerIcon from './pic/shrinkerIcon.png'
import expansionIcon from './pic/expansionIcon.png'

function Table({ data = [], text = '' }) {
    const jsonData = JSON.stringify(data)
    const id = text === '返回参数' ? `_4` : `_3`;

    const dataDeepCopy = (data) => {
        if (typeof data !== 'object' || data == null) {
            return data
        }
        let dataCopy = data instanceof Array ? [] : {};
        for (let key in data) {
            if (data.hasOwnProperty(key)) {
                dataCopy[key] = dataDeepCopy(data[key])
            }
        }
        return dataCopy
    }

    const addIsshow = (data) => {
        const addIsshowData = data.map((item) => {
            if (item.items && item.items.length > 0) {
                item.isshow = false;
                addIsshow(item.items)
            }
            return item
        })
        return addIsshowData
    }
    const addIsshowData = addIsshow(dataDeepCopy(data));
    const [isshowData, setIsshow] = useState(addIsshowData);

    useEffect(() => {
        setIsshow(addIsshowData)
        // console.log('20211103',data)
    }, [jsonData])

    const handleClick = (id) => {
        const changeIsshow = (data) => {
            for (let i = 0; i < data.length; i++) {
                if (data[i].isshow || data[i].isshow === false) {
                    if (data[i].Id === id) {
                        data[i].isshow = !data[i].isshow;
                        return
                    } else {
                        changeIsshow(data[i].items)
                    }
                }
            }

        }
        setIsshow((isshowData) => {
            let itemdataCopy = dataDeepCopy(isshowData);
            changeIsshow(itemdataCopy);
            return itemdataCopy
        });
    }

    const initDataMap = (data) => {
        return data.map((item) => {
            const itemLevel = parseInt(item.resp_level || item.body_level);
            const paddingLeft = itemLevel > 1 ? `${(itemLevel - 1) * 42}px` : '0';
            const paramname = item.paramname || item.respparamname;
            const objpropname = item.objpropname || item.respobjpropname;
            const paramtype = item.paramtype || item.respparamtype;
            const paramdes = item.bodyparamdes || item.respdes;
            const level = item.body_level || item.resp_level;
            const example = item.example || item.respexample;
            return (
                <React.Fragment key={item.Id}>
                    <tr>
                        <td style={{ width: '250px', paddingLeft: paddingLeft }} className={styles.subTableTd}>
                            <img className={styles.expansionIcon}
                                style={{ display: `${(item.isshow || item.isshow === false) ? 'inline-block' : 'none'}` }}
                                onClick={(e) => { handleClick(item.Id, e) }}
                                src={item.isshow ? shrinkerIcon : expansionIcon}
                            >
                            </img>
                            <span title={paramname}>{paramname}</span>
                        </td>
                        {/* <td className={styles.widthFlex} title={objpropname}>{objpropname}</td> */}
                        <td style={{ width: '170px' }} title={objpropname}>{objpropname}</td>
                        <td style={{ width: '100px' }} className={styles.widthFlex} title={paramtype}>{paramtype}</td>
                        <td style={{ width: '140px' }} className={styles.widthFlex} title={paramdes}>{paramdes}</td>
                        <td style={{ width: '50px' }} className={styles.widthFlex} title={level}>{level}</td>
                        <td style={{ width: '150px' }} title={example}>{example}</td>
                    </tr>
                    {item.isshow && initDataMap(item.items)}
                </React.Fragment>
            )
        })
    }
    return (
        <div id={id} className={`${styles.reqbodyparam} controledanchor`}>
            <h2>{text}</h2>
            <table className={styles.tab}>
                <thead>
                    <tr>
                        <td style={{ width: '250px' }}>参数名称</td>
                        <td style={{ width: '170px' }}>对象属性名称</td>
                        {/* <td className={styles.widthFlex}>对象属性名称</td> */}
                        <td style={{ width: '100px' }} className={styles.widthFlex}>参数类型</td>
                        {/* <td className={styles.widthFlex}>说明</td> */}
                        <td style={{ width: '140px' }} className={styles.widthFlex}>说明</td>
                        <td style={{ width: '50px' }} className={styles.widthFlex}>层级</td>
                        <td style={{ width: '150px' }}>示例</td>
                    </tr>
                </thead>
                <tbody>
                    {initDataMap(isshowData)}
                </tbody>
            </table>
        </div>
    )
}

Table.propTypes = {
    data: PropTypes.array,
    text: PropTypes.string
}
export default Table;
